import React from "react";
import { Award, BookOpen, Flame } from "lucide-react";
import { getTranslationsForLanguage } from "@/i18n";

const storageKey = "marstick_daily_learning_progress";
const todayKey = () => new Date().toISOString().slice(0, 10);
const yesterdayKey = () => new Date(Date.now() - 86400000).toISOString().slice(0, 10);

export default function LearningChallengeCard({ lang = "en" }) {
  const t = getTranslationsForLanguage(lang, "dailyBriefing").challenge;
  const challenge = React.useMemo(() => {
    const day = Math.floor(Date.now() / 86400000);
    const questions = t.questions || [];
    const todaysQuestion = questions.length ? questions[day % questions.length] : {};
    return { answer: 0, options: [], ...todaysQuestion, id: `challenge-${day}` };
  }, [t.questions]);
  const [selected, setSelected] = React.useState(null);
  const [progress, setProgress] = React.useState({ completed: [], streak: 0, total: 0 });
  const completedToday = progress.completed.includes(todayKey());
  const badge = progress.streak >= 30 ? t.badges.master : progress.streak >= 14 ? t.badges.reader : progress.streak >= 7 ? t.badges.watcher : progress.total >= 3 ? t.badges.ready : t.badges.new;

  React.useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(storageKey) || "null");
    if (saved) setProgress(saved);
  }, []);

  const submit = () => {
    if (selected !== challenge.answer || completedToday) return;
    const streak = progress.completed.includes(yesterdayKey()) ? progress.streak + 1 : 1;
    const next = { completed: [...new Set([...progress.completed, todayKey()])], streak, total: progress.total + 1 };
    setProgress(next);
    localStorage.setItem(storageKey, JSON.stringify(next));
  };

  return (
    <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-sm font-black uppercase tracking-[0.18em] text-primary">{t.eyebrow}</p><h3 className="mt-2 text-2xl font-black">{t.title}</h3></div>
        <BookOpen className="h-8 w-8 text-primary" />
      </div>
      <p className="mt-4 font-bold leading-7">{challenge.question}</p>
      <div className="mt-4 grid gap-2">
        {challenge.options.map((option, index) => <button key={option} type="button" onClick={() => setSelected(index)} className={`rounded-2xl border px-4 py-3 text-left font-bold ${selected === index ? "border-primary bg-primary/10 text-primary" : "border-border bg-background/70"}`}>{option}</button>)}
      </div>
      <button type="button" onClick={submit} disabled={selected == null || completedToday} className="mt-4 w-full rounded-2xl bg-primary px-4 py-3 font-black text-primary-foreground disabled:opacity-50">{completedToday ? t.completed : t.submit}</button>
      {selected != null && <p className="mt-3 text-sm leading-6 text-muted-foreground">{selected === challenge.answer ? challenge.explanation : t.notQuite}</p>}
      <div className="mt-5 grid grid-cols-3 gap-2 text-center text-sm"><span className="rounded-2xl bg-background/70 p-3"><Flame className="mx-auto h-4 w-4 text-primary" />{progress.streak} {t.dayStreak}</span><span className="rounded-2xl bg-background/70 p-3">{progress.total}<br />{t.completedLabel}</span><span className="rounded-2xl bg-background/70 p-3"><Award className="mx-auto h-4 w-4 text-primary" />{badge}</span></div>
    </article>
  );
}